export enum AnswerPersistenceMode {
    Database = "Database",
    Memory = "Memory",
}
